import { CurrencyEnum } from "../../../../shared/models";

export class CurrencyDetails {
  currency: CurrencyEnum;
  effectiveTime: Date;
  rate: number;
  updateTime: Date;
}
